import { KeyboardArrowUp } from '@mui/icons-material';
import { Typography } from '@mui/material';
import theme from '../../theme/theme';

const ScrollToTop = ({ style }) => (
  <Typography
    variant='h6'
    aria-label='back to the top of the page main navigation eir logo'
    tabIndex={0}
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        // 1. Scroll to top visually
        window.scrollTo({ top: 0 });

        // 2. Prepare focus for NEXT Tab (not now)
        const target = document.querySelector('a.css-11q3xzu');
        if (!target) return;

        const onNextTab = event => {
          if (event.key === 'Tab') {
            event.preventDefault(); // consume this Tab
            target.focus(); // move focus now
            document.removeEventListener('keydown', onNextTab, true);
          }
        };

        document.addEventListener('keydown', onNextTab, true);
      }
    }}
    sx={style}
    onClick={() => window.scrollTo({ top: 0 })}
  >
    <KeyboardArrowUp sx={{ fontSize: theme.typography.h2.fontSize }} /> Back to top
  </Typography>
);

export default ScrollToTop;
